<app-progress-spinner *ngIf="!showGrid || submitted"></app-progress-spinner>

<div class="container">
    
    <div class="label-header">
        <label class="label-headercolor"> Access rights (add new user
        <button (click)="addNewUser()" title="Add">
            <img alt="plusIcon" src="../assets/icons/Plus.svg" width="25" height="25" class="icon-add">
        </button>)  </label>
    </div>
    <!-- <div class="label-header">
        <button (click)="addNewProject()" title="AddProduct" [disabled]="!isEditable"
            [ngClass]="{ 'click-not-allng owed': !isEditable }">
            <img alt="plusIcon" src="../assets/icons/Plus.svg" width="25" height="25" class="icon-add">
        </button>
        <label class="label-headercolor"> to Add product </label>
    </div> -->
     <div *ngIf="showGrid"> 
        <ag-grid-angular id="ConfigurationGrid" style="width: 100%;" class="ag-theme-alpine"
            [rowData]="rowData" [columnDefs]="columnDefs" [domLayout]="domLayout" [defaultColDef]="defaultColDef"
            (gridReady)="onGridReady($event)" (cellValueChanged)="onCellValueChanged($event)" [context]="agGridContext"
            (gridSizeChanged)="onGridSizeChanged($event)" [enableBrowserTooltips]="true" [frameworkComponents]="frameworkComponents">
        </ag-grid-angular>
     </div> 
    <br>

    <div class="row" style="height: 65px; margin-top: 10px;">
        <div class="offset-6 col-md-6">
          <div class="buttonStyle" style="float: right; margin-right: 5px;">
            <button class="button button--small" (click)="onClickCancel()">
              Cancel & Exit</button>&nbsp;
            <button class="button button--small" [disabled]="submitted" (click)="onClickBack()">
              Back</button>&nbsp;
            <button class="button button--small" [disabled]="submitted" (click)="onClickNext()">
              Next</button>&nbsp;
            <button class="button button--small" [disabled]="submitted" (click)="submit($event)" type="submit">
              Save & Exit
            </button>
          </div>
        </div>
      </div>
</div>